<div class="create-circuit">
  <div class="header-create">
    <div class="title">
      {{ pageTitle }}
    </div>
    <div class="subtitle">
      Étape 4 / 5
    </div>
  </div>
  <div class="breadcrumb">
    <li>
      <a style="cursor:pointer;" routerLink="/create-circuit-1" routerLinkActive="active" class="done">
        Information sur le circuit >
      </a>
    </li>
    <li>
      <a style="cursor:pointer;" routerLink="/create-circuit-2" routerLinkActive="active" class="done">
        Ajoutez vos points >
      </a>
    </li>
    <li>
      <a style="cursor:pointer;" routerLink="/create-circuit-3" routerLinkActive="active" class="done">
        Configurez vos points >
      </a>
    </li>
    <li>
      <a style="cursor:pointer;" routerLink="/create-circuit-4" routerLinkActive="active">
        Vérifiez vos points >
      </a>
    </li>
    <li>
      <a style="cursor:pointer;" routerLink="/create-circuit-5" routerLinkActive="active">
        Validation
      </a>
    </li>
  </div>
  <div class="content">
    Contenu
  </div>
  <div class="boutons-change">
    <div class="bouton-prev">
      <a style="cursor:pointer;" routerLink="/create-circuit-3">
        << Revenir
      </a>
    </div>
    <div class="bouton-next">
      <a style="cursor:pointer;" routerLink="/create-circuit-5">
        Suivant >>
      </a>
    </div>
  </div>
</div>
